<template>
    <div 
        class="message-container message-container--error" 
        :class="{hide: !errorMessage}" 
        @click="clearErrorMessage"
    >
        <span 
            class="message" 
            v-if="errorMessage"
        >{{ errorMessage }}</span>
        <i class="fa fa-times message-close" />
    </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
    data: function() {
        return {
            timeout: null,
        };
    },
    computed: {
        ...mapState(['errorMessage']),
    },

    watch: {
        errorMessage: function () {
            window.clearTimeout(this.timeout);
            this.timeout = window.setTimeout(() => {
                this.clearErrorMessage();
            }, 10000);
        }
    },
        
    methods: {
        ...mapMutations(['clearErrorMessage']),
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/ErrorMessageComponent.vue